export const languages = [
    { code: 'en', name: 'English' },
    { code: 'fa', name: 'Farsi' },
    { code: 'ps', name: 'Pashto' },
];